export default "__VITE_ASSET__1b4ec3af__"